import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body overflow-hidden text-center pb-1" }
const _hoisted_3 = { class: "h5 fw-bold mb-0" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-5 position-relative mt-2 small fw-bold" }
const _hoisted_7 = { class: "col-2 lh-1 px-0 text-nowrap" }
const _hoisted_8 = { class: "ps-1" }
const _hoisted_9 = { class: "col-5 position-relative mt-2 small fw-bold" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-5 d-flex flex-column small" }
const _hoisted_12 = { class: "lh-1" }
const _hoisted_13 = { class: "lh-1 small ps-1" }
const _hoisted_14 = { class: "col-5 d-flex flex-column small" }
const _hoisted_15 = { class: "lh-1" }
const _hoisted_16 = { class: "lh-1 small ps-1" }
const _hoisted_17 = { class: "text-end small" }
const _hoisted_18 = { class: "small" }
const _hoisted_19 = { class: "small" }
const _hoisted_20 = { class: "card-footer p-0" }
const _hoisted_21 = { class: "progress border border-secondary" }
const _hoisted_22 = ["aria-valuenow", "aria-valuemax"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h6", { class: "card-header" }, [
      _createElementVNode("i", { class: "fas fa-sitemap me-2" }),
      _createTextVNode("Volumen Calificado")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.totalPoints), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas position-absolute start-50 top-0 translate-middle pb-2", _ctx.warningIconClass(_ctx.points.valid.left, _ctx.points.left)])
            }, null, 2),
            _cache[0] || (_cache[0] = _createTextVNode(" Izquierdo", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.totalPercentage) + " %", 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas position-absolute start-50 top-0 translate-middle pb-2", _ctx.warningIconClass(_ctx.points.valid.right, _ctx.points.right)])
            }, null, 2),
            _cache[1] || (_cache[1] = _createTextVNode(" Derecho", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.leftPoints), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.leftPercentage) + " %", 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-2" }, [
            _createElementVNode("div", { class: "w-50 h-200 border-end" })
          ], -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.rightPoints), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.rightPercentage) + " %", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("span", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.nextPointsRank) + " (" + _toDisplayString(_ctx.accountSummary.unilevelData.nextRankRequiredPoints?.toLocaleString()) + ")", 1),
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-caret-down mx-1 small" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: "progress-bar",
          role: "progressbar",
          style: _normalizeStyle('width:' + _ctx.totalPercentage + '%'),
          "aria-valuenow": _ctx.points.valid.total,
          "aria-valuemin": "0",
          "aria-valuemax": _ctx.accountSummary.unilevelData.nextRankRequiredPoints
        }, _toDisplayString(_ctx.totalPercentage) + "%", 13, _hoisted_22)
      ])
    ])
  ]))
}